import { Modal } from '../SubComponents/Modals';
import { Heading, Text, Label } from '../SubComponents/Text';
import { ModalButton } from '../SubComponents/Buttons';
import { ReactComponent as Wave } from '../Assets/Icons/wave.svg';
import useLocalize from '../Hooks/useLocalize';

interface PaymentSuccessProps {
  heading: string;
  text: string;
  link: string;
  showEmail?: boolean;
  customer: { email?: string | null };
}

const PaymentSuccess = ({
  heading,
  text,
  link,
  showEmail = true,
  customer,
}: PaymentSuccessProps) => {
  const localize = useLocalize();

  return (
    <Modal>
      <Heading mb="3" textAlign="center">
        {heading}
      </Heading>

      <Wave style={{ width: '50px', margin: '0 auto 16px' }} />

      <Text renderWhiteSpace mb="3" textAlign="center">
        {text}
      </Text>

      {showEmail && customer.email && (
        <Text textAlign="center">
          {localize('product.confirmationEmailSentTo')}:{' '}
          <Label bold>{customer.email}</Label>
        </Text>
      )}

      <ModalButton as="a" href={link} target="_blank" rel="noopener noreferrer">
        {localize('product.learnMore')}
      </ModalButton>
    </Modal>
  );
};

export default PaymentSuccess;
